import React from "react";
import {
  Box,
  Typography,
  ThemeProvider,
  createTheme,
  CssBaseline,
} from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0f63a5",
    },
    background: {
      default: "#0f63a5",
    },
  },

});

const IndustryHook: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <Box
        sx={{
          height: "60vh",
          width: "100%",
          backgroundColor: "#0f63a5",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 2,
        }}
      >
        <Box>
          {/* Line 1 */}
          <Typography
            sx={{
              color: "#ffffff",
              fontSize: { xs: "1.8rem", md: "3rem" },
              fontWeight: 500,
              lineHeight: 1.3,
            }}
          >
            We don't hire employees.
          </Typography>

          {/* Line 2 */}
          <Typography
            sx={{
              color: "#d4af37", // gold tone
              fontSize: { xs: "1.8rem", md: "3rem" },
              fontWeight: 600,
              lineHeight: 1.3,
              mt: 1,
            }}
          >
            We build industry leaders.
          </Typography>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default IndustryHook;